<template>
  <v-flex xs10 class="mx-auto">
    <v-card>
      <v-card-text>
        <v-layout wrap>
          
          <v-flex xs12>
            <h3>{{ $t('sendPaymentProofForm') }}:</h3>
          </v-flex>

          <v-flex xs12 md12>
            <DateDialog
              :label="$t('attrs.date')"
              :defaultDate="transactionDate"
              @onSelectDate="val => transactionDate = val"
              ></DateDialog>
          </v-flex>

          <v-flex xs12 md12>
            <v-text-field v-model="amount"
                      name="amount"
                      :label="$t('attrs.paid_amount')"
                      type="number"
                      v-validate="'required|min_value:1'"
                      :error-messages="errors.collect('amount')"
                      data-vv-name="amount"
                      :data-vv-as="$t('attrs.paid_amount')"
                      required
                      ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field 
              :label="$t('selectImage') + '...'" 
              v-model="filename" 
              prepend-icon="attach_file"
              v-validate="'required'"
              :error-messages="errors.collect('image')"
              data-vv-name="image"
              :data-vv-as="$t('attrs.image')"
              required
            ></v-text-field>
            
            <input 
              type="file" 
              style="display: none" 
              ref="file" 
              accept="image/x-png,image/jpeg,application/pdf"
              v-validate="inputFile ? '' : 'required'"
              :error-messages="errors.collect('image')"
              data-vv-name="image"
              :data-vv-as="$t('attrs.image')"
              @change="onFilePicked"
              >
          </v-flex>

          <v-flex xs12 md8 class="text-xs-right">
            <v-btn color="primary" dark :loading="loading" :disabled="loading" @click="pickFile" type="submit">{{ $t('select') }}</v-btn>
          </v-flex>

          <v-flex v-if="url && inputFile && inputFile.type.match(/^image+/)" xs6 md6>
            <v-img
              :src="url"
            ></v-img>
          </v-flex>

          <v-flex xs12 md12 class="text-xs-center">
            <v-btn class="large-btn-size" :loading="sendLoading" :disabled="sendLoading" color="primary" dark @click="save">{{ $t('send') }}</v-btn>
          </v-flex>
            
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import moment from  'moment'
import TransferFund from '@/client/transfer-fund'

export default {

  props: {},

  data () {
    return {
      transactionDate: new Date().toISOString().substr(0, 10),
      amount: '',
      filename: '',
      inputFile: '',
      url: '',
      loading: false,
      sendLoading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    onFilePicked (e) {
      this.loading = true
      if (e.target.files.length > 0) {
        this.inputFile = e.target.files[0]
        this.url = URL.createObjectURL(this.inputFile);
        this.filename = this.inputFile.name
      }
      this.loading = false
    },

    pickFile () {
      this.$refs.file.click()
    },

    async save () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.sendLoading = true  
      try {
        const formData = new FormData()
        formData.append('files[]', this.inputFile)
        formData.append('amount', this.amount)
        formData.append('transaction_date', this.transactionDate)
        await TransferFund.sendPaymentProof(formData)
        this.setNotification({
          color: 'success',
          message: this.$t('paymentProofSentSuccess')
        })
        this.resetFields()
      } catch (err) {
        this.handleErr(err)
      }
      this.sendLoading = false
    },

    resetFields () {
      this.amount = ''
      this.filename = ''
      this.inputFile = ''
      this.url = ''
      this.$validator.reset()
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
